var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import RewardCatalogueRewardQuery from "@irati/reward/apollo/query/RewardCatalogueReward";
import NotFound from "@irati-web/reward/src/components/NotFound";
import { RewardDetailWrapper } from "@irati-web/reward/src/components/Detail";
import { rewardTracking } from "@irati-tracking/reward";
import Layout from "@irati-web/recognition/src/components/Layout";
var RewardDetailContainer = /** @class */ (function (_super) {
    __extends(RewardDetailContainer, _super);
    function RewardDetailContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCompletedRewardCatalogueReward = function (_a) {
            var rewardCatalogueReward = _a.rewardCatalogueReward;
            if (rewardCatalogueReward.isCredit) {
                rewardTracking.rewardsTabStartSendCredit();
            }
            rewardTracking.rewardsTabViewRewardDetails(rewardCatalogueReward);
        };
        return _this;
    }
    RewardDetailContainer.prototype.render = function () {
        var slug = this.props.match.params.slug;
        return (React.createElement(Layout, null,
            React.createElement(RewardCatalogueRewardQuery, { onCompleted: this.onCompletedRewardCatalogueReward, variables: { rewardId: slug }, useLoader: true }, function (_a) {
                var data = _a.data;
                var reward = data && data.rewardCatalogueReward
                    ? data.rewardCatalogueReward
                    : null;
                if (!reward) {
                    return (React.createElement(NotFound, { buttonHref: "/reward", buttonText: "reward.detail.notFound.button" }));
                }
                return React.createElement(RewardDetailWrapper, { reward: reward });
            })));
    };
    return RewardDetailContainer;
}(Component));
export default RewardDetailContainer;
